module.exports = __webpack_public_path__ + "img/aeroland-software-image-05.a716020f.png";